import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-38e134c5"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("div", {
  id: "amapContainer"
})], -1));
const _hoisted_2 = {
  class: "info-button"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_cascader = _resolveComponent("el-cascader");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_form = _resolveComponent("el-form");
  const _component_form_page = _resolveComponent("form-page");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_form_page, null, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.form,
      rules: $data.rules,
      class: "normal-form",
      ref: "form",
      "label-width": "160px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "区域信息",
        prop: "areaId"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_cascader, {
          modelValue: $data.form.areaId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.areaId = $event),
          placeholder: "请选择区域信息",
          style: {
            "width": "100%"
          },
          props: $data.areaProps,
          options: $data.areas
        }, null, 8, ["modelValue", "props", "options"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  }), _hoisted_1, _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
    size: "mini",
    type: "primary",
    plain: "",
    onClick: $options.drawRectangle
  }, {
    default: _withCtx(() => [_createTextVNode("绘制多边形")]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    size: "mini",
    type: "primary",
    plain: "",
    onClick: $options.editRectangle
  }, {
    default: _withCtx(() => [_createTextVNode("编辑多边形")]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    size: "mini",
    type: "danger",
    plain: "",
    onClick: $options.deleRectangle
  }, {
    default: _withCtx(() => [_createTextVNode("删除多边形")]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    size: "mini",
    type: "success",
    plain: "",
    onClick: $options.saveInfo
  }, {
    default: _withCtx(() => [_createTextVNode("保存")]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    size: "mini",
    type: "danger",
    plain: "",
    onClick: $options.closeDT
  }, {
    default: _withCtx(() => [_createTextVNode("取消")]),
    _: 1
  }, 8, ["onClick"])])]);
}